import api from "./utils/api";
import { getAuthToken } from "./utils/tokens";

const getAllWishlist = async () => {
  try {
    const token = getAuthToken();
    const response = await api.get("/wishlist", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const addToWishlist = async (productData) => {
  try {
    // console.log("product data: ", productData);
    const token = getAuthToken();
    const response = await api.post("/wishlist", productData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    // console.log("Response: ", response.data);
    return response.data;
  } catch (error) {
    // console.log("err: ", error);
    // console.log("error: ", error);
    throw error;
  }
};

const removeFromWishlist = async (productId) => {
  try {
    const token = getAuthToken();
    const response = await api.delete(`/wishlist/${productId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
const clearWishlist = async () => {
  try {
    const token = getAuthToken();
    const response = await api.delete("/wishlist", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const getAbandoned = async () => {
  try {
    const token = getAuthToken();
    const data = await api.get("/wishlist/abandoned", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    // console.log("data returned: ", data.data);
    return data.data;
  } catch (err) {
    throw err;
  }
};

export {
  getAllWishlist,
  addToWishlist,
  removeFromWishlist,
  clearWishlist,
  getAbandoned,
};
